export default "__VITE_ASSET__yZC90zSw__"